/**
 * Care Covered — Partner VIP attribution routing (Phase A)
 *
 * Spec: technical/vip-rollout.md Phase A · instructions.md Task 1
 *
 * Flow:
 *   1. Read ?ref= or ?vip_source= from the landing URL
 *   2. If allowlisted → set first-party cookie cc_partner_attribution (30 days)
 *   3. POST /cart/update.js → cart attribute cc_partner_attribution (same value)
 *
 * Allowlist: ameriflex_portal | wfg_dashboard | broker_* (lowercase slug)
 * Invalid refs are ignored (no cookie / no cart write).
 *
 * Debug: open console — logs are prefixed [cc-vip].
 *         Force verbose: ?cc_vip_debug=1 or window.CC_VIP_DEBUG = true
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'cc_partner_attribution';
  var CART_ATTR = 'cc_partner_attribution';
  var COOKIE_DAYS = 30;
  var ALLOWED = /^(ameriflex_portal|wfg_dashboard|broker_[a-z0-9_-]+)$/i;

  function debugEnabled() {
    if (window.CC_VIP_DEBUG === true) return true;
    try {
      return /(?:^|[?&])cc_vip_debug=1(?:&|$)/.test(window.location.search || '');
    } catch (e) {
      return false;
    }
  }

  function log() {
    if (!debugEnabled() && !window.CC_VIP_LOG) return;
    var args = ['[cc-vip]'].concat(Array.prototype.slice.call(arguments));
    if (typeof console !== 'undefined' && console.log) {
      console.log.apply(console, args);
    }
  }

  function warn() {
    var args = ['[cc-vip]'].concat(Array.prototype.slice.call(arguments));
    if (typeof console !== 'undefined' && console.warn) {
      console.warn.apply(console, args);
    }
  }

  function readQueryParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      var re = new RegExp('[?&]' + name + '=([^&#]*)', 'i');
      var m = (window.location.search || '').match(re);
      return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : null;
    }
  }

  function normalizeRef(raw) {
    if (!raw) return '';
    return String(raw).trim();
  }

  function isAllowedRef(value) {
    return !!(value && ALLOWED.test(value));
  }

  function setAttributionCookie(value) {
    var maxAge = COOKIE_DAYS * 24 * 60 * 60;
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      COOKIE_NAME +
      '=' +
      encodeURIComponent(value) +
      '; Path=/' +
      '; Max-Age=' +
      maxAge +
      '; SameSite=Lax' +
      secure;
  }

  function readAttributionCookie() {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + COOKIE_NAME.replace(/[$()*+.?[\\\]^{|}]/g, '\\$&') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : '';
  }

  function syncCartAttribute(value) {
    var body = { attributes: {} };
    body.attributes[CART_ATTR] = value;

    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root
      : '/') + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) {
        throw new Error('cart/update.js HTTP ' + res.status);
      }
      return res.json();
    });
  }

  function resolveAttribution() {
    var fromUrl = normalizeRef(readQueryParam('ref') || readQueryParam('vip_source'));

    if (fromUrl) {
      if (isAllowedRef(fromUrl)) {
        setAttributionCookie(fromUrl);
        // Always-on log when we capture a valid partner ref (staging + prod QA).
        if (typeof console !== 'undefined' && console.log) {
          console.log('[cc-vip] attribution captured from URL:', fromUrl);
        }
        return fromUrl;
      }
      warn('ignored invalid ref:', fromUrl);
      return readAttributionCookie() || '';
    }

    var fromCookie = readAttributionCookie();
    if (fromCookie && isAllowedRef(fromCookie)) {
      log('attribution from cookie:', fromCookie);
      return fromCookie;
    }
    return '';
  }

  function init() {
    var value = resolveAttribution();
    if (!value) {
      log('no partner attribution on this visit');
      return;
    }

    syncCartAttribute(value)
      .then(function () {
        if (typeof console !== 'undefined' && console.log) {
          console.log('[cc-vip] cart attribute synced:', CART_ATTR, '=', value);
        }
      })
      .catch(function (err) {
        warn('cart attribute sync failed:', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
